import styled from 'styled-components'

export const StyledNewsMultiSelect = styled.div``
